import { render, staticRenderFns } from "./TFileDropzone.vue?vue&type=template&id=9dfaa8b0&"
import script from "./TFileDropzone.vue?vue&type=script&lang=ts&"
export * from "./TFileDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./TFileDropzone.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports